import app from './../../../scripts/app';
import { switchToAgent } from '../../../../../shared/api/switchToAgent';
import { switchToHomeowner } from '../../../../../shared/api/switchToHomeowner';
import { isBaseAndProfiFrozen } from '../../../../../shared/utils';
import { camelToDash } from '../../../scripts/utils';
import { trackPubAvailPopupAction } from './PubAvail.tracking';
import { setIdentificationCookies } from './utils/setIdentificationCookies';

const templates = require.context('./templates', true, /\.tpl\.jade$/);
templates.keys().map(templates);

app.directive('cianAfPubAvail', ['pubAvailService', 'httpApi', 'logger', '$cookies', 'addFormService', function(pubAvailService, httpApi, logger, $cookies, addFormService) {
  return {
    restrict: 'E',
    scope: {},
    bindToController: {
      data: '=',
      onContinue: '&?',
      ad: '='
    },
    controllerAs: 'pubAvail',
    template: '<ng-include src="pubAvail.getTemplateUrl()"></ng-include>',
    controller: function (deviceService, geoService, config) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.getTemplateUrl = () => {
        const { windowModeType, identificationInstruction } = this.data;
        const isAgent = !addFormService.ad.isByHomeowner;

        if (!windowModeType) return;

        if (windowModeType === 'HomeownerAndNeedIdentification' && identificationInstruction?.onlyDocumentsAllowed && isAgent) {
          return 'blocks/segments/pub-avail/templates/identification-commercial.tpl.jade';
        }

        const templateName = `${camelToDash(windowModeType)}.tpl.jade`;

        return `blocks/segments/pub-avail/templates/${templateName}`;
      };

      const sendAnalytics = (action) => {
        trackPubAvailPopupAction(this.data.windowModeType, action);
      };

      this.onIdentification = () => {
        sendAnalytics('GoIdentification');
        switchToAgent({ httpApi, logger }).then(() => {
          setIdentificationCookies();
          window.open(this.data.identificationInstruction.identificationUrl);
        }).catch(err => {
          if (err.status === 400 && err.data.errors[0].code === 'cantBeASpecialist') {
            setIdentificationCookies();
            window.open(this.data.identificationInstruction.identificationUrl);
          }
        });
      };

      this.onIdentificationHomeowner = () => {
        switchToHomeowner({ httpApi, logger }, { locationPath: geoService.getLocationPath() }).catch(() => {}).then(() => {
          window.open(this.data.identificationInstruction.identificationUrl);
        });
      };

      this.onSelectTariff = () => {
        sendAnalytics('SelectTariff');
      };

      this.onPay = () => {
        sendAnalytics('Pay');
      };

      this.onContinueBtn = () => {
        sendAnalytics('Continue');
        this.onContinue();
      };

      // ViewAlert только для попапа
      if (this.onContinue) {
        sendAnalytics('ViewAlert');
      }

      this.isTariffsFrozen = () => isBaseAndProfiFrozen({ config, geoService });

      this.getTitleNeedCommercial = () => {
        if (this.isTariffsFrozen()) {
          return 'Необходимо активировать Тариф с подпиской';
        }

        if (this.data.profiAvailable) {
          return 'Необходимо активировать тариф «Базовый» или «Профи»';
        }

        return 'Необходимо активировать тариф «Базовый»';
      };

      this.getTitleOnCommercialDepositRequired = () => {
        if (this.isTariffsFrozen()) {
          return 'Перейдите на Тариф с подпиской';
        }

        return `Перейдите на тариф «Базовый ${this.data.regionName}»`
      };
    }
  };
}]);
